export const Colors = {
    darkslategray: '#2E4159',
    slategray: '#51718C',
    cadetblue: '#698FB6',
    skyblue: '#91B7D9',
    gainsboro: '#E4E4E4',
    mint: '#d5e8d4'
}
